export function getTarget(url, target) {
    const obj = new URL(url);
    if (target === 'origin') {
        return obj.origin;
    }
    else if (target === 'url') {
        return obj.origin + obj.pathname + obj.search + obj.hash;
    }
    else if (target === 'path') {
        return obj.pathname;
    }
    else if (target === 'query') {
        return obj.search;
    }
    else if (target === 'hash') {
        return obj.hash;
    }
    else if (target === 'old_url') {
        return obj.origin + obj.pathname;
    }
    else {
        return obj.href;
    }
}
export function isUrlMatch(url, matchNode) {
    const { match, value } = matchNode;
    const target = getTarget(url, matchNode.target);
    if (target === null)
        return false;
    switch (match) {
        case 'any-of-exact':
            return value.includes(target);
        case 'none-of-exact':
            return !value.includes(target);
        case 'any-of-partial':
            return value.some(v => target.includes(v));
        case 'none-of-partial':
            return value.every(v => !target.includes(v));
        case 'exact':
            return target === value;
        case 'forward':
            return target.indexOf(value) === 0;
        case 'backward': {
            const lengthDiff = target.length - value.length;
            return lengthDiff >= 0 && target.lastIndexOf(value) === lengthDiff;
        }
        case 'partial':
            return target.indexOf(value) !== -1;
        case 'regex':
            try {
                return new RegExp(value).test(target);
            }
            catch {
                return false;
            }
        default:
            return false;
    }
}
export function isMatch(url, node) {
    if (isMatchNode(node)) {
        return isUrlMatch(url, node);
    }
    else {
        if (node.operator === 'not') {
            return !isMatch(url, node.operand);
        }
        else if (node.operator === 'and') {
            return node.operands.every(node => isMatch(url, node));
        }
        else if (node.operator === 'or') {
            return node.operands.some(node => isMatch(url, node));
        }
        else {
            return false;
        }
    }
}
export function isMatchNode(node) {
    if (Object.prototype.hasOwnProperty.call(node, 'operator')) {
        return false;
    }
    else {
        return true;
    }
}
export function isUnaryLogicalNode(node) {
    if (isMatchNode(node))
        return false;
    return node.operator === 'not';
}
export function optimizeLogicalNode(node) {
    if (isMatchNode(node) || isUnaryLogicalNode(node)) {
        return node;
    }
    else if (node.operands.length === 0) {
        throw new Error('node.operands.length === 0');
    }
    else if (node.operands.length === 1) {
        return optimizeLogicalNode(node.operands[0]);
    }
    else {
        return {
            operator: node.operator,
            operands: node.operands.map(optimizeLogicalNode),
        };
    }
}
